import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';

import Iconify from '../../theme/iconify/iconify';

function Pagination({ page, total, changePage }) {
    const { t } = useTranslation();

    return (
        <Grid container justifyContent='center' sx={{ position: 'sticky', bottom: 0, mt: 2, pb: 2 }}>
            <Paper elevation={2} sx={{ border: (theme) => `solid 1px ${theme.palette.divider}` }}>
                <IconButton
                    disabled={page <= 1}
                    onClick={(e) => changePage(-1)}
                >
                    <Iconify icon='eva:arrow-ios-back-fill' />
                </IconButton>
                <Box
                    component='span'
                    sx={{
                        alignSelf: 'center',
                        fontSize: '0.875rem',
                        px: 2,
                        borderLeft: (theme) => `solid 2px ${theme.palette.divider}`,
                        borderRight: (theme) => `solid 2px ${theme.palette.divider}`,
                    }}
                >
                    {page} {t('util.pagination.of')} {total}
                </Box>
                <IconButton
                    disabled={page >= total}
                    onClick={(e) => changePage(1)}
                >
                    <Iconify icon='eva:arrow-ios-forward-fill' />
                </IconButton>
            </Paper>
        </Grid>
    );
}

export default Pagination;